import withShadows from './withShadows';

export default withShadows;
